module.exports = __webpack_public_path__ + "tl.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tl.svg
// module id = 1098
// module chunks = 0